module.exports = __webpack_public_path__ + "static/media/mp4-icon.b6e7f48e.svg";